'use client';

import { Dropdown } from '@/components/atoms';

interface PlayerStatusHeaderProps {
	title: string;
	options: { value: string; label: string }[];
	selectedValue: string;
	onChange: (value: string) => void;
}

export const PlayerStatusHeader = ({ title, options, selectedValue, onChange }: PlayerStatusHeaderProps) => {
	const handleSelect = (value: string) => {
		onChange(String(value));
	};

	return (
		<div className="flex items-center justify-between border-b border-gray-300 px-6 py-5 ">
			<div className=" ">
				<h2 className="text-lg font-semibold">{title}</h2>
				<p className="pt-1 text-sm text-gray-500">Career Stats</p>
			</div>

			<div className="max-w-[110px]">
				<Dropdown options={options} placeholder="Career" onSelect={handleSelect} value={selectedValue} />
			</div>
		</div>
	);
};
